import type React from 'react'
import type { ToastOptions } from 'react-toastify'
import { toast as originalToast } from 'react-toastify'

type ToastHandler = (msg?: string | React.ReactElement | null, options?: ToastOptions) => void
const success: ToastHandler = (msg, options = {}) => {
  const autoClose = options.autoClose ?? 5000
  originalToast.success(msg, { ...options, autoClose })
}

const error: ToastHandler = (msg, options = {}) => {
  const autoClose = options.autoClose ?? 15000
  originalToast.error(msg, { ...options, autoClose })
}

const info: ToastHandler = (msg, options = {}) => {
  const autoClose = options.autoClose ?? 15000
  originalToast.info(msg, { ...options, autoClose })
}

const warning: ToastHandler = (msg, options = {}) => {
  const autoClose = options.autoClose ?? 15000
  originalToast.warning(msg, { ...options, autoClose })
}

export const toast = {
  ...originalToast,
  success,
  error,
  info,
  warning,
}
